import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
  Typography,
  Box,
  Button,
  useTheme,
  alpha,
  Divider
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import AndroidIcon from '@mui/icons-material/Android';
import GetAppIcon from '@mui/icons-material/GetApp';

const DownloadAppModal = ({ open, onClose, apkLink }) => {
  const theme = useTheme();

  if (!apkLink) return null;

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="xs"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: 3,
          background: theme.palette.mode === 'dark' 
            ? 'linear-gradient(135deg, #0A1929 0%, #132f4c 100%)' 
            : 'background.paper',
          overflow: 'hidden'
        }
      }}
    >
      <DialogTitle sx={{ m: 0, p: 2, display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        <Typography variant="h6" fontWeight="bold">Download Mobile App</Typography>
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent sx={{ pb: 4, pt: 1 }}>
        <Box sx={{ textAlign: 'center', display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 2.5 }}>
          <Box
            sx={{
              width: '100%',
              p: 1.5,
              borderRadius: 2,
              bgcolor: alpha(theme.palette.error.main, 0.05),
              border: `1px solid ${alpha(theme.palette.error.main, 0.2)}`,
              display: 'flex',
              alignItems: 'center',
              gap: 1.5,
              mb: 1
            }}
          >
            <Box
              sx={{
                width: 24,
                height: 24,
                borderRadius: '50%',
                border: `1.5px solid ${theme.palette.error.main}`,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                flexShrink: 0
              }}
            >
              <Typography variant="caption" sx={{ color: theme.palette.error.main, fontWeight: 'bold', fontSize: '0.75rem' }}>!</Typography>
            </Box>
            <Typography variant="body2" sx={{ color: theme.palette.error.main, fontWeight: 500, textAlign: 'left' }}>
              Avoid third-party links to stay safe from malware.
            </Typography>
          </Box>

          <Box
            sx={{
              p: 2,
              bgcolor: 'white',
              borderRadius: 2,
              boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <img 
              src={`https://api.qrserver.com/v1/create-qr-code/?size=150x150&data=${encodeURIComponent(apkLink)}`}
              alt="Download QR Code"
              style={{ width: 150, height: 150 }}
            />
          </Box>

          <Divider sx={{ width: '100%', my: 0.5, opacity: 0.5 }} />

          <Box sx={{ width: '100%', textAlign: 'left' }}>
            <Typography variant="subtitle2" sx={{ fontWeight: 800, mb: 2, fontSize: '1rem' }}>
              Steps for Android install:
            </Typography>
            
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
              <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 1.5 }}>
                <Box sx={{ 
                  width: 28, 
                  height: 28, 
                  borderRadius: '50%', 
                  bgcolor: alpha(theme.palette.primary.main, 0.1), 
                  display: 'flex', 
                  alignItems: 'center', 
                  justifyContent: 'center',
                  flexShrink: 0
                }}>
                  <Typography variant="caption" sx={{ color: theme.palette.primary.main, fontWeight: 'bold' }}>⚙️</Typography>
                </Box>
                <Typography variant="body2" sx={{ lineHeight: 1.4 }}>
                  1. In Settings, enable <b>"Install from unknown sources"</b> to install.
                </Typography>
              </Box>

              <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 1.5 }}>
                <Box sx={{ 
                  width: 28, 
                  height: 28, 
                  borderRadius: '50%', 
                  bgcolor: alpha(theme.palette.primary.main, 0.1), 
                  display: 'flex', 
                  alignItems: 'center', 
                  justifyContent: 'center',
                  flexShrink: 0
                }}>
                  <Typography variant="caption" sx={{ color: theme.palette.primary.main, fontWeight: 'bold' }}>⛶</Typography>
                </Box>
                <Typography variant="body2" sx={{ lineHeight: 1.4 }}>
                  2. <b>Scan QR code</b> to download.
                </Typography>
              </Box>
            </Box>
          </Box>

          <Button
            variant="contained"
            fullWidth
            size="large"
            startIcon={<GetAppIcon />}
            href={apkLink}
            target="_blank"
            rel="noopener noreferrer"
            sx={{
              borderRadius: 2,
              py: 1.5,
              textTransform: 'none',
              fontWeight: 'bold',
              boxShadow: theme.shadows[4]
            }}
          >
            Download APK Now
          </Button>

          <Typography variant="caption" color="text.secondary" sx={{ opacity: 0.8 }}>
            Supports Android 7.0 and above
          </Typography>
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default DownloadAppModal;
